$(document).on("click",".product-section-col-2-main-block-show",function() {
  $(this).parent().toggleClass("active");
  $(this).parent().find('.product-section-col-2-main-block-hide').slideToggle();
});

$(document).on("click",".FAQS-section-col-2-main-block-show",function() {
  $(this).parent().toggleClass("active");
  $(this).parent().find('.FAQS-section-col-2-main-block-hide').slideToggle();
});

// $('.fieldset.product-form__input').flickity({
//   wrapAround: true,
//   cellAlign: 'left',
//   contain: true,
//   pageDots: true
// });